// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 Poster 810mm x 1210mm / 31.89in x 47.64in / 2296px x 3430px @ 72 ppi
 Bleed 5mm / 15 px @ 72 ppi
*/
.stopPoster_root__9w4d {
  width: calc(2296px + 30px);
  height: calc(3430px + 30px);
  padding: 64px;
  margin: -15px;
  color: white;
  background: var(--background);
  box-sizing: border-box;
}

.stopPoster_content_P_A9d {
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
  overflow: hidden;
}

.stopPoster_columns_mStqO {
  flex: 1 1 auto;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.stopPoster_column_miJio {
  display: flex;
  flex-flow: column;
  align-items: stretch;
}

.stopPoster_left_QMf9y {
  width: 639px;
}

.stopPoster_leftStretched_ADoGs {
  width: 780px;
}

.stopPoster_right_gA4R8 {
  flex: 1;
}

.stopPoster_adsContainer_hbDZo {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
}

.stopPoster_timetables_yMNT9 {
  flex: 0 0 auto;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.stopPoster_timetable_BkGuM {
  flex: 0 0 auto;
  display: flex;
  align-items: stretch;
}

.stopPoster_timetables_yMNT9 > .stopPoster_timetable_BkGuM {
  flex: 1 0 0;
}

/*
 Poster 700 x 1000mm / 1984px x 2835px @ 72 ppi
*/
.stopPoster_smallTerminalPoster_ADVQg {
  width: calc(1984px + 30px);
  height: calc(2835px + 30px);
}

.stopPoster_smallTerminalPoster_ADVQg .stopPoster_left_QMf9y {
  width: 570px;
}

.stopPoster_smallTerminalPoster_ADVQg .stopPoster_leftStretched_ADoGs {
  width: 670px;
}
`, "",{"version":3,"sources":["webpack://./src/components/stopPoster/stopPoster.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EAEE,YAAY;AACd;;AAEA;EAEE,YAAY;AACd;;AAEA;EAEE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;;CAEC;AACD;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/*\r\n Poster 810mm x 1210mm / 31.89in x 47.64in / 2296px x 3430px @ 72 ppi\r\n Bleed 5mm / 15 px @ 72 ppi\r\n*/\r\n.root {\r\n  width: calc(2296px + 30px);\r\n  height: calc(3430px + 30px);\r\n  padding: 64px;\r\n  margin: -15px;\r\n  color: white;\r\n  background: var(--background);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.content {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  flex-flow: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.columns {\r\n  flex: 1 1 auto;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: space-between;\r\n}\r\n\r\n.column {\r\n  display: flex;\r\n  flex-flow: column;\r\n  align-items: stretch;\r\n}\r\n\r\n.left {\r\n  composes: column;\r\n  width: 639px;\r\n}\r\n\r\n.leftStretched {\r\n  composes: column;\r\n  width: 780px;\r\n}\r\n\r\n.right {\r\n  composes: column;\r\n  flex: 1;\r\n}\r\n\r\n.adsContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 1 100%;\r\n}\r\n\r\n.timetables {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: space-between;\r\n}\r\n\r\n.timetable {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: stretch;\r\n}\r\n\r\n.timetables > .timetable {\r\n  flex: 1 0 0;\r\n}\r\n\r\n/*\r\n Poster 700 x 1000mm / 1984px x 2835px @ 72 ppi\r\n*/\r\n.smallTerminalPoster {\r\n  width: calc(1984px + 30px);\r\n  height: calc(2835px + 30px);\r\n}\r\n\r\n.smallTerminalPoster .left {\r\n  width: 570px;\r\n}\r\n\r\n.smallTerminalPoster .leftStretched {\r\n  width: 670px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `stopPoster_root__9w4d`,
	"content": `stopPoster_content_P_A9d`,
	"columns": `stopPoster_columns_mStqO`,
	"column": `stopPoster_column_miJio`,
	"left": `stopPoster_left_QMf9y stopPoster_column_miJio`,
	"leftStretched": `stopPoster_leftStretched_ADoGs stopPoster_column_miJio`,
	"right": `stopPoster_right_gA4R8 stopPoster_column_miJio`,
	"adsContainer": `stopPoster_adsContainer_hbDZo`,
	"timetables": `stopPoster_timetables_yMNT9`,
	"timetable": `stopPoster_timetable_BkGuM`,
	"smallTerminalPoster": `stopPoster_smallTerminalPoster_ADVQg`
};
module.exports = ___CSS_LOADER_EXPORT___;
